/**
 *
 * Asynchronously loads the component for LessonBuilderContainer
 *
 */

import Loadable from 'react-loadable';
import Spinner from 'components/FullScreenSpinner';

export default Loadable({
  loader: () => import(/* webpackChunkName: "LessonBuilder" */ './index'),
  loading: Spinner,
});
